module.exports = __webpack_public_path__ + "static/img/liushufeng.4a38879.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/liushufeng.png
// module id = p01/
// module chunks = 0